import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';

export class Template {
  public templateid?: number;
  public institutionid?: number;
  public nombre: string;
  public descripcion: string;
}

@Injectable({
  providedIn: 'root'
})

export class TemplateService {
  private readonly apiURL = environment.api_proyecciones;
  private headers = new HttpHeaders().append('Content-Type', 'application/json');
  constructor(
    private http: HttpClient,
  ) { }

  public getTemplates(): Observable <any>{
    const apiURL = this.apiURL + 'api/Listtemplates';
    return this.http.post(`${apiURL}`, { headers: this.headers});
  }

  public postTemplate(temp: any): Observable<any> {
    const templ: Template = {
      nombre: temp.nombre,
      descripcion: temp.descripcion,
      institutionid: temp.institucion,
    } 
    const body = JSON.stringify(templ);
    const apiURL = this.apiURL + 'api/Createtemplate';
    return this.http.post(`${apiURL}`, body, { headers: this.headers});
  }

  public patchTemplate(temp): Observable<any>{
    const tmp: Template = {
      templateid : temp.id,
      nombre: temp.nombre,
      descripcion: temp.descripcion      
    }
    const body = JSON.stringify(tmp);
    const apiURL = this.apiURL + 'api/Updatetemplate';
    return this.http.post(`${apiURL}`, body, { headers: this.headers});
  }
  public deleteTemplate(tempId): Observable<any>{
    const tmp = {
      templateid : tempId,    
    }
    const body = JSON.stringify(tmp);
    const apiURL = this.apiURL + 'api/template/delete';
    return this.http.post(`${apiURL}`, body, { headers: this.headers});
  }
  

}
